import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageAccountAction } from '../coverageAccount.action';

type IDependencies = ICoverageApiDependencySegment;

export const removeCoverageAccountEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageAccountAction.remove.started),
  mergeMap((params) => coverageApi.deleteCoverageAccount(params.serverId, params.reportId, params.accountId).pipe(
    mergeMap(() => [CoverageAccountAction.remove.done({ params })]),
    catchApiError((error) => [
      CoverageAccountAction.remove.failed({ params, error }),
      createApiErrorNotification(error),
    ]),
  )),
);
